// extracted by mini-css-extract-plugin
var _1 = "i5bnP";
var _2 = "S2WzA";
export { _1 as "apply", _2 as "form" }
